//API variable
const serverUrl = 'http://103.18.7.212:1487/';      // server test api url
const honbanUrl = 'http://kesv-er.com';             // honban url
const honbanApiUrl = 'http://kesv-er.com:443/';     // honban api url

const CONSTANT = {
    apiUrl: honbanApiUrl,
    errorCode: {
        "APISuccess": 200,
        "APIUpdatedSuccess": 201,
        "APIDuplicate": 400,
        "TOKENExpired": 401,
        "ClientNotPermission": 403,
        "APINotFound": 404,
        "APIMethodNotSupported": 405,
        "DBCanNotConnect": 500,
        "APIInvalids": 502
    },
    messageCode: {
        emptyData: "018",
        success: "004",
        alreadyDate: "041",
        cannotLogworkThisProject: "046",
        cannotDeleteThisProject: "047",
        requestFail: "010",
    },
    timeOutCallApi: 30000,
    pageRecord: 20
};
export default CONSTANT;
